import { Typography } from '@mui/material'
import { getCompleteDate } from '@operations/utils/format-date'
import { useTranslate } from '@tolgee/react'
import { useFormatMinutesLabel } from '@tom-ui/ui'
import dayjs from 'dayjs'
import { useMemo } from 'react'

interface Props {
  fromDate?: string | null
  fromTime?: string | null
  toDate?: string | null
  toTime?: string | null
}
export const StoppageTime = ({ fromDate, fromTime, toDate, toTime }: Props) => {
  const { t } = useTranslate()
  const { formatMinutesLabel } = useFormatMinutesLabel()

  const time = useMemo(() => {
    if (!fromDate || !fromTime || !toDate || !toTime) return 0

    const from = getCompleteDate(fromDate, fromTime)

    const to = getCompleteDate(toDate, toTime)

    const minutes = dayjs(to).diff(dayjs(from), 'minute')

    return minutes
  }, [fromDate, fromTime, toDate, toTime])

  return (
    <>
      {time !== 0 && (
        <Typography variant='caption' color={time > 0 ? 'inherit' : 'error'}>
          {t('stoopageTime', 'Stoppage time: {time}', {
            time: time > 0 ? formatMinutesLabel(time) : t('negativeTime', 'Negative time'),
          })}
        </Typography>
      )}
    </>
  )
}
